import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

export const usePushNotifications = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [hasPermission, setHasPermission] = useState(false);

  useEffect(() => {
    const initPushNotifications = async () => {
      // Push notifications só funcionam em plataformas nativas
      if (!Capacitor.isNativePlatform()) {
        setIsInitialized(true);
        setHasPermission(false);
        return;
      }

      try {
        await import('../services/pushNotificationService');
        // Service is already initialized in AuthContext
        // Just set the state
        setIsInitialized(true);
        setHasPermission(true);
      } catch (error) {
        console.error('Failed to initialize push notifications:', error);
        setIsInitialized(true);
        setHasPermission(false);
      }
    };

    initPushNotifications();
  }, []);

  return {
    isInitialized,
    hasPermission,
  };
};
